"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Themes = exports.ImageThemes = exports.IconTypes = void 0;
var IconTypes;
(function (IconTypes) {
    IconTypes["CHAT"] = "CHAT";
    IconTypes["PENCIL"] = "PENCIL";
    IconTypes["NOTIFICATION"] = "NOTIFICATION";
    IconTypes["SAVE"] = "SAVE";
    IconTypes["DELETE"] = "DELETE";
})(IconTypes || (exports.IconTypes = IconTypes = {}));
var ImageThemes;
(function (ImageThemes) {
    ImageThemes["ROUNDED"] = "ROUNDED";
    ImageThemes["MULTIPLE"] = "MULTIPLE";
    ImageThemes["CIRCLE"] = "CIRCLE";
    ImageThemes["ICON"] = "ICON";
})(ImageThemes || (exports.ImageThemes = ImageThemes = {}));
var Themes;
(function (Themes) {
    Themes["DEFAULT"] = "DEFAULT";
    Themes["BORDER"] = "BORDER";
})(Themes || (exports.Themes = Themes = {}));
